import { useApiStore } from "../store";
import { ClientType } from "./clientType";
import type { ApiBatchRoute, ApiRoute } from "./types";

export { ClientType } from "./clientType";

export function unwrapRoute(route: ApiRoute): string {
  if (!route) return "";
  return route.trim();
}

export function unwrapRoutes(routes: ApiBatchRoute): string[] {
  if (!routes) return [];
  return routes.map(unwrapRoute).filter((route) => !!route);
}

export function generateRoute(route: ApiRoute, clientType: ClientType) {
  switch (clientType) {
    case ClientType.Portfolio:
      return portfolioRoute(route);
    case ClientType.Tenant:
      return tenantRoute(route);
    default:
      return baseRoute(route);
  }
}

export function generateRoutes(routes: ApiBatchRoute, clientType: ClientType) {
  return unwrapRoutes(routes).map((route) => generateRoute(route, clientType));
}

function portfolioRoute(route: ApiRoute) {
  const portfolioId = useApiStore.getState().portfolioId;
  if (!portfolioId) return "";
  if (!unwrapRoute(route)) return `/portfolios/${portfolioId}`;
  return `/portfolios/${portfolioId}/${unwrapRoute(route)}`;
}

function tenantRoute(route: ApiRoute) {
  const tenantId = useApiStore.getState().tenantId;
  if (!tenantId) return "";
  if (!unwrapRoute(route)) return `/tenants/${tenantId}`;
  return `/tenants/${tenantId}/${unwrapRoute(route)}`;
}

function baseRoute(route: ApiRoute) {
  if (!unwrapRoute(route)) return "";
  return unwrapRoute(route);
}
